import { render } from "./About.vue?vue&type=template&id=d581ad9c"
const script = {}
script.render = render

export default script